const serverMessageMap = {
  // ── Auth ─────────────────────────────────────────────────────────────────
  'Invalid credentials': {
    el: 'Λανθασμένο όνομα χρήστη ή κωδικός πρόσβασης.',
    en: 'Invalid username or password.',
  },
  'Too many attempts. Please try again later.': {
    el: 'Πάρα πολλές προσπάθειες. Παρακαλώ δοκιμάστε αργότερα.',
    en: 'Too many attempts. Please try again later.',
  },

  // ── Register ──────────────────────────────────────────────────────────────
  'User exists': {
    el: 'Υπάρχει ήδη λογαριασμός με αυτό το email ή όνομα χρήστη.',
    en: 'An account with this email or username already exists.',
  },

  // ── Profile / Users ───────────────────────────────────────────────────────
  'Username or email already exists': {
    el: 'Το όνομα χρήστη ή το email χρησιμοποιείται ήδη.',
    en: 'Username or email is already taken.',
  },
  'User not found': {
    el: 'Ο χρήστης δεν βρέθηκε.',
    en: 'User not found.',
  },
  'Not authorized to update this profile': {
    el: 'Δεν έχετε δικαίωμα να επεξεργαστείτε αυτό το προφίλ.',
    en: 'You are not authorised to edit this profile.',
  },
  'Failed to update profile': {
    el: 'Αποτυχία ενημέρωσης προφίλ.',
    en: 'Failed to update profile.',
  },
  'Too many update attempts. Please try again later.': {
    el: 'Πάρα πολλές προσπάθειες ενημέρωσης. Παρακαλώ δοκιμάστε αργότερα.',
    en: 'Too many update attempts. Please try again later.',
  },

  // ── Contact ───────────────────────────────────────────────────────────────
  'Too many requests, please try again later.': {
    el: 'Πάρα πολλά αιτήματα. Παρακαλώ δοκιμάστε αργότερα.',
    en: 'Too many requests. Please try again later.',
  },
  'All fields are required.': {
    el: 'Παρακαλώ συμπληρώστε όλα τα πεδία.',
    en: 'All fields are required.',
  },
  'Failed to store message': {
    el: 'Αποτυχία αποστολής μηνύματος.',
    en: 'Failed to send message.',
  },

  // ── Generic server ────────────────────────────────────────────────────────
  'Server error': {
    el: 'Σφάλμα διακομιστή. Παρακαλώ δοκιμάστε αργότερα.',
    en: 'Server error. Please try again later.',
  },
  'Internal server error': {
    el: 'Εσωτερικό σφάλμα διακομιστή. Παρακαλώ δοκιμάστε αργότερα.',
    en: 'Internal server error. Please try again later.',
  },
};

/**
 * @param {string} msg   - The raw message string returned by the backend.
 * @param {string} lang  - The current app language: 'el' or 'en'.
 * @returns {string}     - The translated string, or the original msg if no
 *                         mapping exists (safe fallback).
 */
export const translateServerMsg = (msg, lang = 'el') => {
  const entry = serverMessageMap[msg];
  if (!entry) return msg; // unknown message — show as-is
  return entry[lang] ?? entry.en; // fall back to English if lang key missing
};
